<template>
  <div
    v-if="errorMessage"
    class="panel error"
  >
    <h2>
      <span v-if="errorTitle">{{ errorTitle }}</span>
      <span v-else>{{ $gettext('Error') }}:</span>
      <Icon
        name="danger"
        fill="white"
        class="pull-right"
      />
    </h2>
    <p>{{ errorMessage }}</p>
  </div>
  <Loader
    v-else
    ditto-plus
  />
</template>

<script setup lang="ts">
import { useGettext } from 'vue3-gettext'
import Icon from './Icon.vue'
import Loader from './Loader.vue'

defineProps({
  errorTitle: { type: String, default: '' },
  errorMessage: { type: String, default: '' },
})

const { $gettext } = useGettext()
</script>
